import { vm } from '@/main';
import { DateTime } from 'luxon';

export function getOutgoingInvoiceLayoutOptions() {
  return [
    { id: 'Custom', label: vm.$t('Eigenes Layout') },
    { id: 'Classic', label: vm.$t('Klassisch') },
    { id: 'Modern', label: vm.$t('Modern') },
    { id: 'Other', label: vm.$t('Logo oben rechts') },
    { id: 'Other2', label: vm.$t('Logo oben rechts 2') },
  ];
}

export interface IOutgoingInvoicePlaceholders {
  DateFrom?: string;
  DateTo?: string;
}
